import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createStructuredSelector } from 'reselect';
import {
  IframeWrapper,
  Title,
  Button,
} from './styledComponents';
import H1 from 'components/H1';
import { selectUser } from '../App/selectors';
import { encodeBase64 } from '../../utils/helpers';
import Spinner from 'components/Spinner';
import { ButtonWrapper } from '../LeadsPage/LeadsList/styledComponents';
import ButtonLink from '../../components/Button/ButtonLink';

class ChannelAnalytic extends Component {
  state = {
    loading: true
  }

  render() {
    const { permissionRole, user: { authToken }, match: { params: { channelId } } } = this.props;
    const iframeUrl = process.env.REACT_APP_MVBTH_ANALYTIC_ROOT || "https://movebooth-staging-pr-631.herokuapp.com";
    const url = `${iframeUrl}/ch/${channelId}/analytics?token=${encodeBase64(`${authToken}/${channelId}`)}&from_api=true`;
    return (
      <IframeWrapper>
        <Title>
          <H1>Analytics</H1>
          <Button className="cancel" onClick={() => this.props.history.push('/channels')}>
            Back to Channels
          </Button>
        </Title>
        {permissionRole !== "lite" ? (
          <div className="iframe-container">
            {this.state.loading && <Spinner />}
            <iframe
              src={url}
              width="100%"
              height="100%"
              className={!this.state.loading ? "show" : ""}
              onLoad={() => this.setState({ loading: false })}
            />
          </div>
        ) : (
          <div style={{ marginTop: "5em" }}>
            <ButtonWrapper>
              <ButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to access analytics for my channel!">
                Upgrade to PLUS for Analytics
              </ButtonLink>
            </ButtonWrapper>
          </div>
        )}
      </IframeWrapper>
    );
  }
}


const mapStateToProps = createStructuredSelector({
    user: selectUser(),
    permissionRole: (state) => state.app.user.permission_role,
  });

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChannelAnalytic));



// WEBPACK FOOTER //
// ./src/containers/AnalyticsPage/ChannelAnalytic.js